import { useEffect, useState } from 'react';

import * as API from 'src/services/api';
import { EmbeddableLookerDashboard } from 'src/services/apiInterfaces';

// Legacy "Assist Analytics" Looker dashboard. Hidden from the sidebar and
// blocked at the route level so users can't reach it via direct URL either.
export const DISALLOWED_LOOKER_DASHBOARD_IDS = new Set([69]);

export default function useEmbeddedDashboardSettings() {
  const [settings, setSettings] = useState<EmbeddableLookerDashboard[] | null>(
    null,
  );

  useEffect(() => {
    API.getLookerDashboardSettings()
      .then(dashboards =>
        setSettings(
          dashboards.filter(
            ({ looker_dashboard_id }) =>
              !DISALLOWED_LOOKER_DASHBOARD_IDS.has(looker_dashboard_id),
          ),
        ),
      )
      .catch(() => console.error('Error loading embedded dashboard settings'));
  }, []);

  return settings;
}
